const BASE_URL = '/api/admin-panel/tpo-denial-categories';

export class TpoDenialConfigurationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCategories() {
    return this.#http.get(BASE_URL);
  }

  async createCategory({ name }) {
    return this.#http.post(BASE_URL, { name });
  }

  async updateCategory({ categoryId, name }) {
    return this.#http.put(`${BASE_URL}/${categoryId}`, { name });
  }

  async deleteCategory({ categoryId }) {
    return this.#http.delete(`${BASE_URL}/${categoryId}`);
  }

  async createReason({ categoryId, ...reason }) {
    return this.#http.post(`${BASE_URL}/${categoryId}/reasons`, reason);
  }

  async updateReason({ categoryId, reasonId, ...reason }) {
    return this.#http.put(`${BASE_URL}/${categoryId}/reasons/${reasonId}`, reason);
  }

  async deleteReason({ categoryId, reasonId }) {
    return this.#http.delete(`${BASE_URL}/${categoryId}/reasons/${reasonId}`);
  }
}
